import { AxiosResponse } from "axios";
import { axiosInstance } from "src/services/axiosSetup";
import * as API from "src/services/consts/ScheduleCall";

export function createScheduleCallbackApiRequest(data: any, queryParam: any): Promise<AxiosResponse<any>> {
  return axiosInstance
    .post(
      `${API.URL_CREATE_CALLBACK_REQUEST}?email=${queryParam?.email}&campaign_name=${queryParam?.campaign_name}`,
      data
    )
    .then((d: AxiosResponse) => d.data);
}

export function updateNewsletterRequestApiRequest(data: any): Promise<AxiosResponse<any>> {
  return axiosInstance.put(`${API.URL_UPDATE_NEWSLETTER_REQUEST}`, data).then((d: AxiosResponse) => d.data);
}
